import api from './api';

/**
 * Servicio para interactuar con el sistema de facturación ARCA (ex AFIP)
 */
const invoiceService = {
  /**
   * Verificar estado de ARCA
   * @returns {Promise} Estado de configuración y autenticación
   */
  async getStatus() {
    try {
      const response = await api.get('/invoices/status');
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al verificar estado de ARCA'
      };
    }
  },

  /**
   * Obtener tipos de comprobante disponibles
   * @returns {Promise} Objeto con tipos de comprobante
   */
  async getTiposComprobante() {
    try {
      const response = await api.get('/invoices/tipos-comprobante');
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener tipos de comprobante'
      };
    }
  },

  /**
   * Obtener tipos de documento disponibles
   * @returns {Promise} Objeto con tipos de documento
   */
  async getTiposDocumento() {
    try {
      const response = await api.get('/invoices/tipos-documento');
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener tipos de documento'
      };
    }
  },

  /**
   * Generar factura electrónica para una venta
   * @param {number} saleId - ID de la venta
   * @param {Object} data - Datos de la factura
   * @param {number} data.tipo_comprobante - Tipo de comprobante (6=Factura B, 11=Factura C)
   * @param {number} data.documento_tipo - Tipo de documento (80=CUIT, 96=DNI, 99=Consumidor Final)
   * @param {number} data.documento_nro - Número de documento
   * @returns {Promise} Datos de la factura generada
   */
  async generateForSale(saleId, data) {
    try {
      const response = await api.post(`/invoices/generate-for-sale/${saleId}`, data);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al generar factura',
        data: error.response?.data?.data || null
      };
    }
  },

  /**
   * Listar facturas emitidas
   * @param {Object} params - Parámetros de filtrado
   * @param {number} params.page - Número de página
   * @param {number} params.limit - Items por página
   * @param {string} params.startDate - Fecha desde (YYYY-MM-DD)
   * @param {string} params.endDate - Fecha hasta (YYYY-MM-DD)
   * @param {string} params.tipo - Filtrar por tipo
   * @returns {Promise} Lista de facturas con paginación
   */
  async list(params = {}) {
    try {
      const response = await api.get('/invoices/list', { params });
      return {
        success: true,
        data: response.data.data,
        pagination: response.data.pagination
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al listar facturas'
      };
    }
  },

  /**
   * Obtener factura asociada a una venta
   * @param {number} saleId - ID de la venta
   * @returns {Promise} Datos de la factura
   */
  async getBySale(saleId) {
    try {
      const response = await api.get(`/invoices/sale/${saleId}`);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener factura'
      };
    }
  }
};

export default invoiceService;

